<form [formGroup]="vaccineHistoryForm" (ngSubmit)="submitForm()">
  <div class="mb-8 mt-4 w-full flex justify-end">
    <p-float-label>
      <p-datepicker [id]="id + 'data-aplicacao'" appendTo="body" formControlName="date" dateFormat="dd/mm/yy"
        [pTooltip]="formWatched['children']['date']() | formFieldFeedback" [maxDate]="today" tooltipEvent="hover"
        class="max-w-[160px]" required />
      <label [for]="id + 'data-aplicacao'">Data da Aplicação</label>
    </p-float-label>
  </div>
  <div class="md:flex md:gap-4 md:mb-8 mb-8">
    <p-float-label [id]="id + 'nome'" class="w-full mb-8 md:mb-0">
      <input pInputText type="text" formControlName="name"
        [pTooltip]="formWatched['children']['name']() | formFieldFeedback" tooltipEvent="focus" tooltipPosition="bottom"
        required class="w-full" />

      <label [for]="id + 'nome'">Nome</label>
    </p-float-label>
    <p-float-label class="w-full mb-8 md:mb-0">
      <input [id]="id + 'dose'" pInputText type="text" formControlName="dose"
        [pTooltip]="formWatched['children']['dose']() | formFieldFeedback" tooltipEvent="focus" tooltipPosition="bottom"
        class="w-full" required />
      <label [for]="id + 'dose'">Dose</label>
    </p-float-label>

    <p-float-label class="w-full mb-8 md:mb-0">
      <p-datepicker [id]="id + 'proxima-dose'" appendTo="body" formControlName="nextDose" dateFormat="dd/mm/yy"
        [pTooltip]="formWatched['children']['nextDose']() | formFieldFeedback" [minDate]="today" tooltipEvent="hover"
        class="w-full" styleClass="w-full" />
      <label [for]="id + 'proxima-dose'">Próxima dose</label>
    </p-float-label>
  </div>
  <div class="mb-4">
    <p-float-label>
      <textarea [id]="id + 'detalhes'" rows="5" pTextarea formControlName="detail"
        [pTooltip]="formWatched['children']['detail']() | formFieldFeedback" resize="none" tooltipEvent="focus"
        tooltipPosition="bottom" class="w-full"></textarea>
      <label [for]="id + 'detalhes'">Detalhes</label>
    </p-float-label>
  </div>
  <p-button styleClass="w-full mb-4 font-semibold" [loading]="isLoading()" [disabled]="isLoading() || !enabled()"
    type="submit" [label]="initialData() ? 'Atualizar' : 'Cadastrar'" />
</form>